import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { ApiService, HomeAssistantResponse } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from "@angular/router";
import Swiper, { SwiperOptions } from 'swiper';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

import {map, startWith} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  searchForm: FormGroup;
  user: any;
  currentDateTime: any;
  doctors: any;
  loading: boolean = true;
  homeText = '';
  specialities:any;
  accessToken:any;
  hospitals:any;
  branches:any;
  selectedDoctorId: string | null = '';
  selectedHospitalId:any = "";
  selectedBranchId:any = "";
  selectedSpecialityId:any = "";
  doctorName:any = '';
  bookingId: any;
  bookingUserDetails: any;
  error:any = '';
  isHospitalApp: any;
  showBtn: boolean = true;
  doctorParams:any;
  totalSpecialities: any;
  allBranches: any;
  allSpecialities: any;
  errorMessage: string = "";
  swiperEl: any;
 swiperParams: any;
  // allDoctors: any;

  allDoctors: any[] = [];
  filteredDoctors!: Observable<any[]>;
  selectedDocId : any;
  hospitalId: any;
  appointmentRequest = '';
  appointmentReply = '';
  appointmentError = '';
  appointmentLoading = false;
  appointmentSpecialtyId: number | null = null;
  appointmentSpecialty = '';
  appointmentDate: string | null = null;
  appointmentTimeOfDay: string | null = null;
  appointmentSuggestions = [
    'I need to see a skin doctor tomorrow',
    'Consult a cardiologist this evening',
    'Pediatrician appointment next Monday',
    'General physician for fever & flu'
  ];
  
  constructor(public datePipe: DatePipe, private apiService: ApiService,
    public authService: AuthService, private storage: StorageService, private router: Router, private spinner: NgxSpinnerService, private formBuilder: FormBuilder, private snackBar: MatSnackBar,) {
      // Initialize FormGroup in constructor
      this.searchForm = this.formBuilder.group({
        branches: [''],
        specialities: [''],
        doctorName: [''],
      });
  }


  // Function for storing branch to get doctors according to branch & navigating to doctors page
  gotoDoctorsList(branch?: any) {
    // if(this.doctorParams) {
    //   this.router.navigate(['/doctors', this.doctorParams]);
    // }
    if(branch){
      this.router.navigate(['/doctors', { branchId: branch.id }]);
    }else{
      this.router.navigate(['/doctors']);
    }
  }

  openAiBooking(): void {
    this.router.navigate(['/ai-booking']);
  }

  // goToHospitalDoctorsList() {
  //   if(this.hospitalId) {
  //     this.router.navigate(['/doctors', {branchId: this.hospitalId}]);
  //   }
  // }

  // Function for storing hospital id to get branches navigating to branches page
  gotoBranches(hospitalId?: any) {   
    this.router.navigate([`/${hospitalId}/branches`]);
  }
   

  // Function for storing speciality to get doctors according to speciality & navigating to doctors page
  gotoSpecialityDoctorsList(specialty?: any) {
    this.router.navigate(['/doctors', { specialtyId: specialty.id }]);
  }

  // Function for storing branch to get specialities according to branch & navigating to specialities page 
  gotoSpecialities() {
    if(this.selectedHospitalId) {
      this.router.navigate(['/specialities', { hospitalId: this.selectedHospitalId }]);
    }else {
      this.router.navigate(['/specialities']);
    }
  }

  // Function for storing doctor details, doctor id & navigating to booking page
  bookNow(doctor: any) {
    this.storage.set('selectedDoctor', JSON.stringify(doctor));
    this.router.navigate(['/booking', doctor.id]);
  }

  // Api call for getting all hospitals
 getHospitals(){
  this.apiService.getAllHospitals().subscribe({
   next:  (response: any) => {
      if (response.success === true) {
        this.hospitals = response.data.data        
        this.loading = false;
        // hiding spinner
        this.spinner.hide();
      }
  },
  error: (err: any) => {
    this.snackBar.open(err.message, '', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'text-center'
    });
    // hiding spinner
    this.spinner.hide();
  },
  complete: () => {
    // hiding spinner
    this.spinner.hide();
  }
 });
}

// Fetch branches for the selected hospital
getBranchesForHospital(hospitalId: string) {
  // showing spinner
  this.spinner.show();
  this.apiService.getHospitalBranches(hospitalId).subscribe({
   next: (response: any) => {
      if (response.success === true) {
        this.allBranches = response.data;
        this.branches = [...this.allBranches];
        this.loading = false;
        // hiding spinner
        this.spinner.hide();
      }
    },
    error: (err: any) => {
      this.snackBar.open(err.error.message, '', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'text-center'
      });
      this.error = err.error.message;
      this.allBranches = [];
      // hiding spinner
      this.spinner.hide();
    },
    complete: () => {
      // hiding spinner
      this.spinner.hide();
    }
  });
}

  // Api call for getting all branches
  getAllBranches(){
    this.apiService.getBranches().subscribe({
     next:  (response: any) => {
      if (response.success === true) {
        this.branches = response.data.data;
        this.allBranches = response.data.data;
        this.loading = false;
        // hiding spinner
        this.spinner.hide();
      } 
      },
      error: (err: any) => {
        this.snackBar.open(err.error.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.error = err.error.message;
        // hiding spinner
        this.spinner.hide();
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }


  // Fetch departments for the selected hospital
getDepartmentsForHospital(hospitalId: string) {
  this.spinner.show();
  this.apiService.getHospitalDepartments(hospitalId).subscribe({
   next: (response: any) => {
      this.processSpecialtiesResponse(response);
    },
    error: (err: any) => {
      this.processErrorResponse(err);
    },
    complete: () => {
      // hiding spinner
      this.spinner.hide();
    }
  });
}

getAllSpecialties() {
  this.spinner.show();
  this.apiService.geAllSpecialties().subscribe({
   next: (response: any) => {
      this.processSpecialtiesResponse(response);
    },
    error: (err: any) => {
      this.processErrorResponse(err);
    },
    complete: () => {
      // hiding spinner
      this.spinner.hide();
    }
  });
}


processSpecialtiesResponse(response:any){
  if (response.success === true) {
    this.allSpecialities = response.data.data;
    this.specialities = [...this.allSpecialities].slice(0, 3);
    
    this.specialities = [...this.allSpecialities].slice(0, 4);
    this.loading = false;
    // hiding spinner
    this.spinner.hide();
  }
}

processErrorResponse(err:any){
  this.snackBar.open(err.error.message, '', {
    duration: 2000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
    panelClass: 'text-center'
  });
  this.error = err.error.message;
  this.allBranches = [];
  // hiding spinner
  this.spinner.hide();
}

 // Fetch departments for the selected branch
 getDepartmentsForBranch(branchId: string) {
  this.spinner.show();
  this.apiService.getBranchDepartments(branchId).subscribe({
   next: (response: any) => {
      // if (response.success === true) {
      //   this.allSpecialities = response.data.data;
      //   this.specialities = [...this.allSpecialities];
      //   this.loading = false;
      //   // hiding spinner
      //   this.spinner.hide();
      // }
      this.processSpecialtiesResponse(response);
    },
    error: (err: any) => {
      this.snackBar.open(err.error.message, '', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'text-center'
      });
      this.error = err.error.message;
      this.allBranches = [];
      // hiding spinner
      this.spinner.hide();
    },
    complete: () => {
      // hiding spinner
      this.spinner.hide();
    }
  });
}

  // Api call for getting all Hospital Departments
  getSpecialties(){
    this.apiService.getDepartments().subscribe((response: any) => {
      if (response.success === true) {
        this.allSpecialities = response.data.data;
        let completeSpecialties = response.data.data.slice(0, 4);
        this.specialities = completeSpecialties;
        this.totalSpecialities = this.allSpecialities;
        this.loading = false;
      } 
    });
  }

  // Function for getting home page text
  getHomeText() {
    this.apiService.getHomeText().subscribe((response: any) => {
      if (response.success === true) {
        this.homeText = response.data;
      }
    });
  } 

   // Event handler when hospital selection changes
   onHospitalSelectionChange(selectedHospitalId: string) {
    this.selectedHospitalId = selectedHospitalId;
    // Clear the branches list while fetching new branches
    this.allBranches = [];
    this.branches = [];
    this.allSpecialities = [];
    this.specialities = [];
    this.doctorName = '';
    this.error = "";
    this.filteredDoctors = of([]);
    this.doctorParams = {
      'hospitalId': this.selectedHospitalId
    };
    if(this.selectedHospitalId) {
      this.getBranchesForHospital(this.selectedHospitalId);
      this.getDepartmentsForHospital(this.selectedHospitalId);
      this.getAllDoctors(this.doctorParams);
      
       // Recalculate the filtered doctors after the hospital selection changes
  this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
    startWith(''),
    map(value => this._filterDoctors(value || ''))
  );
    } else {
      this.getAllDoctors(null);
      this.getAllBranches();
      this.getSpecialties();
    }

   
  }
  
  // Event for getting branch id
  onBranchSelectionChange(selectedBranchId: number | string) {
    // Assigning selectedBranchId to any variable
    this.selectedBranchId = selectedBranchId;
    this.doctorParams = {
      'branchId': this.selectedBranchId
    };
    if(this.selectedBranchId) {
      this.getDepartmentsForBranch(this.selectedBranchId);
      this.getAllDoctors(this.doctorParams);
      // Recalculate the filtered doctors after the branch selection changes
  this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
    startWith(''),
    map(value => this._filterDoctors(value || ''))
  );
    } else {
      this.getSpecialties();
    }

    
  }

  askAppointmentAssistant(): void {
    const message = this.appointmentRequest.trim();
    if (!message || this.appointmentLoading) {
      return;
    }

    this.appointmentLoading = true;
    this.appointmentReply = '';
    this.appointmentError = '';
    this.appointmentSpecialtyId = null;
    this.appointmentSpecialty = '';
    this.appointmentDate = null;
    this.appointmentTimeOfDay = null;

    this.apiService.homeBookingAssistant(message).subscribe({
      next: (response: HomeAssistantResponse) => {
        this.appointmentLoading = false;
        if (!response.success || !response.data) {
          this.appointmentError = response.message || 'I could not understand that appointment request.';
          return;
        }

        this.appointmentReply = response.data.reply;
        this.appointmentSpecialtyId = response.data.specialty_id;
        this.appointmentSpecialty = response.data.specialty || '';
        this.appointmentDate = response.data.appointment_date;
        this.appointmentTimeOfDay = response.data.time_of_day;

        if (this.appointmentSpecialtyId) {
          this.selectedSpecialityId = this.appointmentSpecialtyId;
          this.searchForm.patchValue({ specialities: this.appointmentSpecialtyId });
          this.doctorParams = {
            specialtyId: this.appointmentSpecialtyId,
            branchId: this.selectedBranchId
          };
          this.getAllDoctors(this.doctorParams);
        }
      },
      error: (error: any) => {
        this.appointmentLoading = false;
        this.appointmentError = error?.error?.message || 'The booking assistant is temporarily unavailable.';
      }
    });
  }

  selectSuggestion(prompt: string): void {
    this.appointmentRequest = prompt;
    this.askAppointmentAssistant();
  }

  clearAppointmentRequest(): void {
    this.appointmentRequest = '';
    this.appointmentReply = '';
    this.appointmentError = '';
    this.appointmentSpecialty = '';
    this.appointmentDate = null;
    this.appointmentTimeOfDay = null;
  }

  // Event for getting speciality id
  onSpecialitySelectionChange(selectedSpecialityId: number | string) {
    // Assign selectedBranchId to variable
    this.selectedSpecialityId = selectedSpecialityId;
    this.doctorParams = {
      'specialtyId': this.selectedSpecialityId,
      'branchId' : this.selectedBranchId
    };
    if(this.selectedSpecialityId) {
      this.getAllDoctors(this.doctorParams);
       // Recalculate the filtered doctors after the speciality selection changes
  this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
    startWith(''),
    map(value => this._filterDoctors(value || ''))
  );
    }

   
  }

  // Function to handle doctor selection from the dropdown
  onDoctorSelection(event: any) {
    const selectedDoctor = event.option.value; // Extract the selected doctor object
    this.selectedDocId = selectedDoctor.title;
    

    this.doctorParams = {
      'specialtyId': this.selectedSpecialityId,
      'branchId': this.selectedBranchId,
      'searchTerm': this.selectedDocId
    };

    this.getSearchDoctors(this.doctorParams);

     // Ensure the filteredDoctors observable is updated
  // this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
  //   startWith(''),
  //   map(value => this._filterDoctors(value || ''))
  // );
  }

  getSearchDoctors(doctorParams: any) {
    this.spinner.show();
    this.apiService.getBranchDoctorsList(doctorParams).subscribe(
      {
        next: (response: any) => {
          if (response.success === true) {
            this.allDoctors = response.data.data;
            // this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
            //   startWith(''),
            //   map(value => this._filterDoctors(value || ''))
            // ); // Update filteredDoctors observable
            if (this.allDoctors.length > 4) {
              this.showBtn = true;
              this.doctors = this.allDoctors.slice(0, 3);
            } else {
              this.doctors = this.allDoctors;
              this.showBtn = false;
            }
            this.spinner.hide();
          } else {
            this.error = response.message;
            this.showBtn = false;
          }
        },
        error: (err: any) => {
          this.error = err.data.message;
          this.spinner.hide();
          this.showBtn = false;
          this.filteredDoctors = of([]);
        }
      }
    );
  }

  // getHospitalDoctors(hospitalId: string) {
  //   this.spinner.show();
  //   this.apiService.getHospitalDoctorsList(hospitalId).subscribe(
  //     {
  //       next: (response: any) => {
  //         if (response.success === true) {
  //           this.allDoctors = response.data.data;
  //           this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
  //             startWith(''),
  //             map(value => this._filterDoctors(value || ''))
  //           ); // Update filteredDoctors observable
  //           if (this.allDoctors.length > 3) {
  //             this.showBtn = true;
  //             this.doctors = this.allDoctors.slice(0, 3);
  //           } else {
  //             this.doctors = this.allDoctors;
  //             this.showBtn = false;
  //           }
  //           this.spinner.hide();
  //         } else {
  //           this.error = response.message;
  //           this.showBtn = false;
  //         }
  //       },
  //       error: (err: any) => {
  //         this.error = err.data.message;
  //         this.spinner.hide();
  //         this.showBtn = false;
  //         this.filteredDoctors = of([]);
  //       }
  //     }
  //   );
  // }

  getAllDoctors(doctorParams: any) {
    this.spinner.show();
    this.apiService.getBranchDoctorsList(doctorParams).subscribe(
      {
        next: (response: any) => {
          if (response.success === true) {
            this.allDoctors = response.data.data;
            this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
              startWith(''),
              map(value => this._filterDoctors(value || ''))
            ); // Update filteredDoctors observable
            if (this.allDoctors.length > 3) {
              this.showBtn = true;
              this.doctors = this.allDoctors.slice(0, 3);
            } else {
              this.doctors = this.allDoctors;
              this.showBtn = false;
            }
            this.spinner.hide();
          } else {
            this.error = response.message;
            this.showBtn = false;
          }
        },
        error: (err: any) => {
          this.error = err.data.message;
          this.spinner.hide();
          this.showBtn = false;
          this.filteredDoctors = of([]);
        }
      }
    );
  }

  // Api for listing doctors according to search params
  search() {
    this.doctorParams = {
      'hospitalId': this.selectedHospitalId ? this.selectedHospitalId : this.hospitalId,
      'branchId': this.selectedBranchId,
      'specialtyId': this.selectedSpecialityId,
      'searchTerm': this.selectedDocId ? this.selectedDocId : ''
    };
    if(!this.hospitalId) {
      if(this.selectedHospitalId ) {
        if(this.allDoctors.length > 0) {
          this.router.navigate(['/doctor-list', this.doctorParams]);
        }else {
          this.snackBar.open('Sorry, no doctors found in this field. Please try a broader search.', '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
        }
      }else {
        this.snackBar.open('Please select a hospital and continue.', '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
      }
    }else {
      if(this.selectedBranchId ) {
        if(this.allDoctors.length > 0) {
          this.router.navigate(['/doctor-list', this.doctorParams]);
        }else {
          this.snackBar.open('Sorry, no doctors found in this field. Please try a broader search.', '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
        }
      }else {
        this.snackBar.open('Please select a branch and continue.', '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
      }
    }
  }

  // Function for getting user booking details according to booking or phone no
  getUserBookingDetails(bookingId: any) {
    this.apiService.getBookingDetails(bookingId).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.bookingUserDetails = response;
          this.storage.set('km_participant_id', this.bookingUserDetails.user_id);
          this.storage.set('med_participant_booking_details', JSON.stringify(this.bookingUserDetails));
        }else {
          // this.storage.remove('token');
        }
      },
      error: (err: any) => {
        this.errorMessage = err.error.message;
        setTimeout(() => {
          this.errorMessage = "";
        }, 6000);
        // this.storage.remove('token');
      },
      complete: () => { }
    });
  }
 
  // NgOnInit function
  ngOnInit(): void {  
    this.isHospitalApp = environment.isHospitalApp; 
    this.hospitalId = environment.hospitalId; 
    this.doctorParams = {
      'hospitalId': this.hospitalId
    };
    this.storage.remove('selectedDoctor');
      this.accessToken = this.storage.get('token');
      this.currentDateTime = this.datePipe.transform((new Date), 'MM/dd/yyyy h:mm:ss');
      this.user = this.authService.getUser();     
      if(this.user){     
        this.getUserBookingDetails(this.user.data.phone);
      }
      // Calling function for getting home page text
      this.getHomeText();
      // Checking isHospitalApp or not
      if (!this.isHospitalApp) { 
              
        this.getHospitals();
        this.getAllBranches();
        this.getAllSpecialties();
        this.getAllDoctors(this.doctorParams);
      } else {        
        this.getBranchesForHospital(this.hospitalId);
        this.getDepartmentsForHospital(this.hospitalId);
        this.getAllDoctors(this.doctorParams);
      }
      // Function call for getting all specialities
      // this.getSpecialties();
      // Function call for getting all doctors
      // this.getAllDoctors(this.doctorParams);

      // Setup the filteredDoctors observable based on form control value changes
    this.filteredDoctors = this.searchForm.controls['doctorName'].valueChanges.pipe(
      startWith(''),
      map(value => this._filterDoctors(value || ''))
    );
  }

  // Filter doctors based on the input name
  private _filterDoctors(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.allDoctors.filter(doctor => doctor.title.toLowerCase().includes(filterValue));
  }

  // Display the doctor name in the autocomplete field
  displayDoctorFn(doctor: any): string {
    return doctor && doctor.title ? doctor.title : '';
  }

}
